<script>
import {mapState, mapActions} from 'vuex';

export default {
    props: {
        label: {
            type: String,
            required: true
        },
        method: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            comment: ''
        }
    },
    computed: {
        ...mapState({
            site: state => state.allocation.form.filters.selected.site.name,
            accommodation: state => state.allocation.form.filters.selected.accommodation.name,
            submitted: state => state.allocation.form.submit.submitted,
            accepted: state => state.allocation.form.submit.accepted,
            cancelled: state => state.allocation.form.submit.cancelled,
            alerts: state => state.allocation.form.submit.alerts,
            user: state => state.auth.user,
        }),
    },
    methods: {
        ...mapActions({
            cancel: 'allocation/cancelForm',
            addAllocationComment: 'allocation/addAllocationComment',
        }),
        accept() {
            if (this.comment !== '') {
                this.addAllocationComment(this.comment)
            }
            this.$emit('accept');
        },
        close($event) {
            this.comment = '';
            if ($event.target.id === 'container') {
                this.cancel();
            }
        }
    }
}
</script>
<template>
    <div class="manage-allocation-form-accept">
        <transition name="fade" mode="out-in">
            <div v-if="submitted" id="container"
                 class="manage-allocation-form-accept__container"
                 @click="close($event)">
                <div class="manage-allocation-form-accept__body">
                    <div class="manage-allocation-form-accept__header">
                        {{ label }}
                    </div>
                    <div class="manage-allocation-form-accept__content">
                        {{ $t('manageAllocationFormAccept.content.start.' + method) }}
                        <strong> {{ site }}</strong>
                        {{ $t('manageAllocationFormAccept.content.end') }}
                        <div class="manage-allocation-form-accept__list">
                            <div class="manage-allocation-form-accept__name">
                                {{ accommodation }}
                            </div>
                        </div>
                        <span v-html="$t('manageAllocationFormAccept.content.note')"/>
                        <div v-if="alerts.length > 0" class="manage-allocation-form-accept__alert">
                            <strong>{{ $t('manageAllocationFormAccept.alert.start') }}
                                <div v-for="(alert, index) in alerts"
                                     :key="index"
                                     class="manage-allocation-form-accept__messages">
                                    {{ $t('manageAllocationFormAccept.alert.from') }}
                                    {{ alert.from }}
                                    {{ $t('manageAllocationFormAccept.alert.to') }}
                                    {{ alert.to }}
                                </div>
                            </strong>
                        </div>
                        <div v-if="user.contractManager" class="manage-allocation-form-accept__comment">
                            <div class="manage-allocation-form-accept__comment-label">
                                {{ $t('manageAllocationFormAccept.content.comment') }}
                            </div>
                            <textarea :value="comment"
                                      class="manage-allocation-form-accept__comment-text"
                                      cols="60"
                                      rows="8"
                                      @input="comment = $event.target.value"/>
                        </div>
                    </div>
                    <div class="manage-allocation-form-accept__button-group">
                        <button class="manage-allocation-form-accept__submit" @click="accept">
                            {{ $t('manageAllocationFormAccept.buttons.accept') }}
                        </button>
                        <button class="manage-allocation-form-accept__cancel" @click="cancel">
                            {{ $t('manageAllocationFormAccept.buttons.cancel') }}
                        </button>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ManageAllocationFormAccept/ManageAllocationFormAccept.vue